/**
 * Handles keyboard navigation for dropdown menus
 * @param {KeyboardEvent} e - The keyboard event
 * @param {Function} onItemSelect - Callback function when an item is selected
 */
export const handleDropdownKeyboardNavigation = (
  e,
  onItemSelect,
  LABELS_KEYS_MAP
) => {
  // Only handle keys when dropdown is open
  const dropdown = document.querySelector(
    '.ant-dropdown:not(.ant-dropdown-hidden)'
  )
  if (!dropdown) return

  const { key } = e
  const menuItems = dropdown.querySelectorAll('[role="menuitem"]')
  if (menuItems.length === 0) return

  const currentIndex = Array.from(menuItems).findIndex(
    (item) => item === document.activeElement
  )
  if (key === 'Escape' || key === 'Tab') {
    const actionBtn = document.querySelector('.action-button')
    if (actionBtn) {
      actionBtn.click()
      return
    }
  }
  if (key === 'ArrowDown') {
    e.preventDefault()
    e.stopPropagation()
    const nextIndex = (currentIndex + 1) % menuItems.length
    menuItems[nextIndex]?.focus()
  } else if (key === 'ArrowUp') {
    e.preventDefault()
    e.stopPropagation()
    const prevIndex =
      currentIndex <= 0 ? menuItems.length - 1 : currentIndex - 1
    menuItems[prevIndex]?.focus()
  } else if (key === 'Enter' || key === ' ') {
    e.preventDefault()
    e.stopPropagation()
    const focusedElement = document.activeElement
    if (focusedElement && focusedElement.getAttribute('role') === 'menuitem') {
      const menuKey = LABELS_KEYS_MAP[focusedElement?.textContent]
      if (menuKey && onItemSelect) {
        onItemSelect({ key: menuKey })
        document.querySelector('.action-button')?.click()
      }
    }
  }
}
